/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faSquare } from '@fortawesome/free-solid-svg-icons/faSquare'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage, useIntl } from 'react-intl'
import SelectableRow from '../../../../../client/js/components/selection/SelectableRow'
import FormattedDuration from '../../FormattedDuration'
import { getLeaseTemplateLink } from '../../../lib/links/leaseTemplateLinks'
import { Button, Group, Table } from '@mantine/core'
import AnchorLink from '../../../../../client/js/components/AnchorLink'

export type LeaseTemplateListItemProps = {
  item: LeaseTemplate
}

function LeaseTemplateListItem (props: LeaseTemplateListItemProps) {
  const intl = useIntl()
  const { item } = props
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <AnchorLink to={getLeaseTemplateLink(item.id)}>
          {item.name}
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        {typeof item.furnished === 'boolean'
          ? <Group gap="xs">
            <FontAwesomeIcon
              fixedWidth
              icon={item.furnished ? faCheckSquare : faSquare}
            />
            {item.furnished
              ? <FormattedMessage
                id="furnished"
                defaultMessage="Meublé"
              />
              : <FormattedMessage
                id="not_furnished"
                defaultMessage="Non meublé"
              />
            }
          </Group>
          : null}
      </Table.Td>
      <Table.Td>
        {typeof item.managed === 'boolean'
          ? <Group gap="xs">
            <FontAwesomeIcon
              fixedWidth
              icon={item.managed ? faCheckSquare : faSquare}
            />
            {item.managed
              ? <FormattedMessage
                id="managed"
                defaultMessage="Géré"
              />
              : <FormattedMessage
                id="not_managed"
                defaultMessage="Non géré"
              />
            }
          </Group>
          : null}
      </Table.Td>
      <Table.Td>
        {typeof item.duration !== 'number'
          ? <FontAwesomeIcon
            fixedWidth
            icon={faExclamationTriangle}
          />
          : <FormattedDuration
            value={item.duration}
            unit={item.durationUnit}
          />
        }
      </Table.Td>
      <Table.Td>
        {typeof item.noticeDuration !== 'number'
          ? <FontAwesomeIcon
            fixedWidth
            icon={faExclamationTriangle}
          />
          : <FormattedDuration
            value={item.noticeDuration}
            unit={item.noticeDurationUnit}
          />
        }
      </Table.Td>
      <Table.Td ta="end">
        <Button
          to={`/api/lease-templates/${item.id}/file`}
          rel="noopener"
          component={AnchorLink}
          target="_blank"
          size="xs"
          leftSection={<FontAwesomeIcon fixedWidth icon={faDownload} />}
        >
          {intl.formatMessage({
            id: 'download',
            defaultMessage: 'Télécharger'
          })}
        </Button>
      </Table.Td>
    </SelectableRow>
  )
}

export default LeaseTemplateListItem
